import { useCallback, useState } from 'react';

const STORAGE_KEY = 'side_nav_collapsed';

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Collapsed (icons only) state of the desktop side navigation, remembered per browser. */
export function useSideNavCollapsed() {
  const [collapsed, setCollapsedState] = useState(readCollapsed);

  const setCollapsed = useCallback((value: boolean) => {
    setCollapsedState(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Storage unavailable (private mode, blocked site data): keep the state for this page only.
    }
  }, []);

  return [collapsed, setCollapsed] as const;
}
